import { render, staticRenderFns } from "./PesquisaLocal.vue?vue&type=template&id=1a0a8ab2&"
import script from "./PesquisaLocal.vue?vue&type=script&lang=js&"
export * from "./PesquisaLocal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports